import React, { useState } from "react";

import Footer from "../../../../../components/common/Footer";
import PageHeading from "../../../../../components/common/PageHeading";
import RightBar from "../../../../../components/common/RightBar";
import RightBarMethod from "../../../../../components/common/RightBar/RightBarMethod";

import { Button, Card, Col, Input, Row } from "antd";

import { RiCloseCircleLine, RiAddCircleFill } from "react-icons/ri";

import "./ManageManualFields.css";

const ManageManualFieldsRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod("Lease Templates", "1", "", "", "/leasing/leases/lease-templates"),
    RightBarMethod("Management Agreement Templates", "2", "", "", ""),
  ]),
];

function ManageManualFields() {
  const [inputFields, setInputFields] = useState([{ fieldName: "" }]);
  const [edit, setEdit] = useState(false);

  const addInputField = () => {
    setInputFields([...inputFields, { fieldName: "" }]);
  };

  const removeInputFields = (index) => {
    const rows = [...inputFields];
    rows.splice(index, 1);
    setInputFields(rows);
  };

  const handleChange = (index, event) => {
    const { name, value } = event.target;
    const list = [...inputFields];
    list[index][name] = value;
    setInputFields(list);
  };

  const handleSubmit = () => {
    setInputFields([...inputFields]);
    setEdit(false);
  };

  return (
    <>
      <div className="page-container">
        <div className="main-container">
          <PageHeading heading="Manage Manually Entered Fields" />

          <div className="manage-manual-fields">
            {edit ? null : (
              <Button
                className="edit-btn"
                type="link"
                onClick={() => setEdit(true)}
              >
                Edit
              </Button>
            )}
            <Row gutter={[0, 16]}>
              <Col span={24}>
                <p>
                  The fields you create on this page will appear as optional
                  merge fields in templates you create. They can be manually
                  filled in prior to sending out a document.
                </p>
              </Col>
              <Col span={24}>
                <Card title="Manual Fields">
                  {edit ? (
                    <>
                      <Row>
                        <Col span={22} className="header-row">
                          <span>Field Name</span>
                        </Col>
                      </Row>
                      {inputFields.map((item, index) => {
                        return (
                          <Row
                            className="data-row"
                            key={index}
                            gutter={[16, 0]}
                            align="middle"
                          >
                            <Col span={22}>
                              <Input
                                name="fieldName"
                                value={item.fieldName}
                                onChange={(event) => handleChange(index, event)}
                              />
                            </Col>
                            {inputFields.length > 1 ? (
                              <Col span={2}>
                                <RiCloseCircleLine
                                  size={20}
                                  onClick={() => removeInputFields(index)}
                                />
                              </Col>
                            ) : null}
                          </Row>
                        );
                      })}
                      <button
                        onClick={() => addInputField()}
                        className="add-btn"
                      >
                        <RiAddCircleFill />
                        <span>Add Another Field</span>
                      </button>
                      <Row gutter={[6, 0]}>
                        <Col>
                          <Button type="primary" onClick={() => handleSubmit()}>
                            Save
                          </Button>
                        </Col>
                        <Col>
                          <Button onClick={() => setEdit(false)}>Cancel</Button>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <>
                      <Row>
                        <Col span={24} className="field-name-header">
                          <span>Field Name</span>
                        </Col>
                      </Row>
                      {inputFields.map((item, index) => {
                        return (
                          <>
                            {item.fieldName !== "" ? (
                              <Row key={index} className="field-name">
                                <Col>
                                  <span>{item.fieldName}</span>
                                </Col>
                              </Row>
                            ) : null}
                          </>
                        );
                      })}
                    </>
                  )}
                </Card>
              </Col>
            </Row>
          </div>
          <Footer />
        </div>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={ManageManualFieldsRightBar} />
      </div>
    </>
  );
}

export default ManageManualFields;
